var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2513 21.875H23.3346V24.7917H26.2513M26.2513 16.0417H23.3346V18.9583H26.2513M29.168 27.7083H17.5013V24.7917H20.418V21.875H17.5013V18.9583H20.418V16.0417H17.5013V13.125H29.168M14.5846 10.2083H11.668V7.29167H14.5846M14.5846 16.0417H11.668V13.125H14.5846M14.5846 21.875H11.668V18.9583H14.5846M14.5846 27.7083H11.668V24.7917H14.5846M8.7513 10.2083H5.83464V7.29167H8.7513M8.7513 16.0417H5.83464V13.125H8.7513M8.7513 21.875H5.83464V18.9583H8.7513M8.7513 27.7083H5.83464V24.7917H8.7513M17.5013 10.2083V4.375H2.91797V30.625H32.0846V10.2083H17.5013Z",
    fill: "#5981E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyBlue);
export default __webpack_public_path__ + "static/media/company_blue.de4a34e0d4c8c9c0ebe4d8f27e9d1082.svg";
export { ForwardRef as ReactComponent };